<template>
  <v-container fluid>
    <!-- Search bar -->
    <v-row align="center">
      <v-col cols="6" class="text-left mb-2">
        <v-text-field v-model="search" label="Recherche" single-line hide-details></v-text-field>
      </v-col>
    </v-row>

    <!-- Data table for displaying data -->
    <v-data-table locale="fr" :headers="headers" :search="search" no-data-text="Aucune fiche trouvée"
      :items="this.$store.getters['Auth/getFicheQuitus']" @click:row="goto" class="elevation-1 mb-5 px-5">
    </v-data-table>
  </v-container>
</template>

<script>
import { mapActions } from "vuex";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";

export default {
  components: { DatePicker },
  data: () => ({
    search: "",
    headers: [
      { text: "ID / Libelle / Version", align: "start", sortable: false, value: "libelle" },
      { text: "Nom de la fiche", sortable: false, value: "fileName" },
    ],
  }),
  created() {
    this.$store.dispatch("Auth/loadAllFichesQuitus");
    this.$store.dispatch("Auth/getData");
  },
  methods: {
    ...mapActions({
      loadAll: "Auth/loadAllFichesQuitus",
    }),
    goto(value) {
      const { id } = value;
      this.$router.push({ name: "show_modele_fiche_quitus", params: { id: id } });
    },
  }
};
</script>

<style></style>